import { useTheme } from '@mui/material';
const useCustomRadioGroupStyles = () => {
    const theme = useTheme();
    return {
        FormControlLabelStyles: {
            '.MuiFormControlLabel-label': {}
        }
    };
};
export default useCustomRadioGroupStyles;
